import React from "react";
import { Link } from 'react-router-dom';
import { scrollFunction } from "../functions/Functions";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
// import {
//   Icon,
//   //Button,
// } from "semantic-ui-react";
const data =[
  {name:'Home',fn:()=>scrollFunction('home'),},
  {name:'About Us',fn:()=>scrollFunction('about'),},
  {name:'Services',fn:()=>scrollFunction('service')},
  {name:'Why Choose Us',fn:()=>scrollFunction('why')},
  {name:'Reviews',fn:()=>scrollFunction('review')},
  {name:'Awards',fn:()=>scrollFunction('award')},  
  {name:'Contact Us',fn:()=>scrollFunction('contact')},   
  ]
// const data =[
//   {link:"#home",name:'Home'},
//     {link:"#about",name:'About Us'},
//     {link:"#service",name:'Services'},
//     {link:"#why",name:'Why Choose Us'},
//     {link:"#review",name:'Reviews'},
//     {link:"#award",name:'Awards'}, 
// ]
const QuickLink = (props) => {

  
  //*************** */
  return (
    <section>
      
          <div className="flex-center font-family-Nunito list-style-none "
          style={{background:'rgba(0, 0, 0, 0.7)',padding:'10px 20px'}}
          >
            
          {
data.map( (val,index)=>{
  // <div key={val.name}>
  //               <li className="px-0 link-gr"
  //               onClick={val.fn}
  //               >
  //                 {/* <a className="link-gr" href={val.link}>
  //                   {val.name}
  //                 </a> */}{val.name}
  //               </li>
  //             </div>
  
    return (
      <div  key={index}>
      <li   className="" onClick={val.fn}
    >
    <span className="color-white link-gr1">{val.name}</span>
    <span className="px-0 color-white">|</span>
    </li>
    
    </div>
    )
  
})
}

            


  <div>
  <li className="" 
>
<Link  className="color-white link-gr1" to="/dwk/">Properties Dwarka</Link>
<span className="px-0 color-white">|</span>
</li>

</div>
<div>
    <li  
  >
  <Link  className="color-white link-gr1" to="/ggn/">Properties Dwarka Expressway</Link>
  <span className="px-0 color-white">|</span>
  </li>
  
  </div>
  <div>
    <li  
  >
  <a className="color-white link-gr1"
      onClick={props.handleCookiesPolicyModal}
      >Cookies Policy
      </a>
      <span className="px-0 color-white">|</span>
  </li>
  
  </div>
  <div>
    <li  
  >
  <a      className="color-white link-gr1"
      onClick={props.handlePrivacyPolicyModal}
      >Privacy Policy
      </a>
  </li>
  
  </div>
  
          


          </div>
          <div className="mt-10 mb-10">
          <ul className="flex-center font-family-Nunito ">
						<li>
							<a href="https://www.facebook.com/GuptaRealtorsProperty"><FaFacebookF className='icon-gr' style={{backgroundColor:'#007FFF',}}/></a>
						</li>
						<li><a href="https://www.instagram.com/guptarealtors/?hl=en"><FaInstagram className='icon-gr' 
            style={{background:"linear-gradient(to bottom right, #f9ce34, #ee2a7b,#6228d7)",}}/></a></li>
						<li><a href="https://twitter.com/GuptaRealtors"><FaXTwitter className='icon-gr' style={{backgroundColor:'black',}}/></a></li>
						<li><a href="https://www.linkedin.com/authwall?trk=bf&amp;trkInfo=AQE7nOHuWqVg1QAAAXO-tGgo-vG3IOabunRpXl8LTawAhA_Q_EREIKlIH7L8pDh7T_Ofid5rgbesTlg12XEWBO-0UzM36g0lyN2XNcYO2rc2sjzxB6Av84wmbQD5N2F5fU4gpM0=&amp;originalReferer=&amp;sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fgupta-realtors---india%2Fabout%2F"><FaLinkedinIn className='icon-gr' style={{backgroundColor:'#007FFF',}}/></a></li>
            <li><a href="https://www.youtube.com/results?search_query=gupta+realtors"><FaYoutube className='icon-gr' style={{backgroundColor:'#EF0107',}}/></a></li>
          </ul>
          </div>
       
    </section>
  );

};

export default QuickLink;
